<template>
  <newsletter-component
    documents-name="Newsletters"
    :documents="newsletters" />
</template>

<script>
// import DocumentsComponent from '../components/DocumentsComponent'
import NewsletterComponent from '../components/NewsletterComponent.vue'

export default {
  data: () => ({
    newsletters: []
  }),

  components: {
    // DocumentsComponent
    NewsletterComponent
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit('toggle_dialog', true)

      vm.$http.get('newslettersV2/' + vm.$store.state.Dbasename)
        .then(resp => {
          vm.newsletters = resp.data
          vm.$store.commit('loading', false)
        })
    })
  },

  mounted () {
    this.$store.dispatch('logReadItems')
  }
}
</script>
